// extracted by mini-css-extract-plugin
export default {"alert-danger":"rgb(218, 30, 40)","footer":"FormModalFooter_footer__stbDC","content":"FormModalFooter_content__l9aCr","error":"FormModalFooter_error__0ccBJ"};